import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  loginMain: {
    height: "100vh",
    // height: "calc(100vh - 50px)"
    // [theme.breakpoints.down("xs")]: {
    //   height: "calc(100vh - 50px)"
    // }
  },
  loginWrapperPaper: {
    // height: "calc(85vh - 50px)",
    // height: 580,
    height: 610,
    minHeight: 610,
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    padding: (props) => (props.type === "login" ? "" : theme.spacing(4)),
  },
  loginWrapperPaperMobile: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    paddingTop: theme.spacing(6),
    height: "100%",
    position: "relative",
  },
  emailError: {
    // backgroundColor: "#FDF6F6",
  },
  emailInput: {
    fontSize: 15,
    padding: "14px 12px",
  },
  emailRoot: {
    borderRadius: 8,
  },
  socialLogin: {
    backgroundColor: "#FAFAFA",
    borderRadius: 10,
    border: "1px solid #DFE1E6",
    boxShadow: "none",
    width: "100%",
    height: 60,
    "&:hover": {
      backgroundColor: "#FAFAFA",
      boxShadow: "0px 7px 20px 5px rgba(0, 36, 224, 0.08)",
      border: "1px solid #0D8BFF",
    },
  },
  loginButton: {
    width: 306,
    fontFamily: "Open Sans",
    fontSize: 15,
    fontWeight: 600,
    textTransform: "none",
    borderRadius: 8,
    boxShadow: "none",
    padding: theme.spacing(1.5, 2.5),
    justifyContent: "flex-start",
    color: "#fff",
    "&:hover": {
      boxShadow: "none",
    },
  },
  buttonLabel: {
    marginLeft: 43,
  },
  googleButton: {
    backgroundColor: "#EB4335",
    "&:hover": {
      backgroundColor: "#BC352A",
    },
  },
  facebookButton: {
    backgroundColor: "#1990FF",
    "&:hover": {
      backgroundColor: "#1164b2",
    },
  },
  appleButton: {
    backgroundColor: "#091E42",
    "&:hover": {
      backgroundColor: "#213454",
    },
  },
  weChatButton: {
    backgroundColor: "#07C160",
    "&:hover": {
      backgroundColor: "#05A150",
    },
  },
  emailButton: {
    backgroundColor: "#fff",
    color: theme.palette.primary.main,
    border: "1px solid #DFE1E6",
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
  },
  loginStartIcon: {
    marginLeft: 0,
    marginRight: 12,
  },
  showPasswordCheck: {
    paddingLeft: 0,
  },
  successDialogue: {
    padding: theme.spacing(3),
    position: "relative",
    width: 530,
    maxWidth: 530,
    minHeight: 315,
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  closeIcon: {
    position: "absolute",
    transform: "translate(-50%, -50%)",
    top: "26px",
    right: 4,
    borderRadius: "50%",
    backgroundColor: theme.palette.custom.dividerColor,
    color: theme.palette.custom.lessonDarkButtons,
    fontSize: 21,
    cursor: "pointer",
  },
  gotoportfolio: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 600,
    padding: "12px 16px",
    width: "100%",
    backgroundColor: "#EDF6FF",
    color: theme.palette.primary.main,
    borderRadius: 8,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#EDF6FF",
      opacity: "0.9",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px 4px",
      fontSize: 13,
    },
  },
  continueTrading: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 600,
    padding: "12px 16px",
    width: "100%",
    borderRadius: 8,
    [theme.breakpoints.down("xs")]: {
      padding: "8px 4px",
      fontSize: 13,
    },
  },
  cursorUnavailable: {
    cursor: "not-allowed",
  },
}));

export { useStyles };
